import { FieldDesc } from '90.quickConnect.Models/models';

const updateItemsFieldOrChild = (
  fullPathId: string,
  field: FieldDesc,
  items: FieldDesc[],
  state: { found: boolean } = { found: false },
) => {
  if (state.found) return;

  if (field.fullPathId.toLowerCase() === fullPathId) {
    // on remplace les items et on stop
    field.items = [...items];
    state.found = true;
    return;
    // Pas besoin d'update le stateId car la méthode getFieldKey utilise l'id des enfants de manière récursive
  }
  if (field.items && field.items.length > 0) {
    for (const child of field.items) {
      if (!state.found) updateItemsFieldOrChild(fullPathId, child, items, state);
    }
  }
};

export default updateItemsFieldOrChild;
